module.exports = __webpack_public_path__ + "img/Icon-material-first-page.37119182.svg";